import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es';
import { 
  DateTimePicker as DateTimePickerMaterial, 
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { DateTimePickerWrapper, StyledDateTimePicker } from './style';

const DateTimePicker = ({ 
  value, 
  onChange, 
  disabled, 
  width='100%', 
  name, 
  format, 
  helperText, 
  error, 
  placeHolder='' 
}) => {

  return (
    <DateTimePickerWrapper width={width}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
        <ThemeProvider theme={ StyledDateTimePicker }>
          <DateTimePickerMaterial
            ampm
            name={name}
            value={value} 
            format={format}
            helperText={helperText}
            onChange={onChange}
            error={error}
            disabled={disabled}
            emptyLabel={placeHolder}
          />
        </ThemeProvider>
      </MuiPickersUtilsProvider>
    </DateTimePickerWrapper>
  )
}

export default DateTimePicker;
